export default "../fonts/b955258564018726d2d22a32d81fca6a.svg";